import { Env } from '@didi/utils'
import { wechatReady } from '../core/wechat'
import { assert } from '../util/tool'

export default function onWeChatReady(func) {
  assert(typeof func === 'function', 'the parameter of onWeChatReady must be a function')
  if (Env.isWechat) {
    wechatReady((err, wx) => {
      if (!err) {
        func && func(null, wx)
      } else {
        func && func(err)
      }
    })
  }
}
